import { APIError } from '../APIError';
import { RawAgent } from '../types';

type SetAgentMapAction = {
  readonly type: 'set_agents';
  readonly clearStore: boolean;
  readonly agentList: RawAgent[];
};

type SetAgentsLoadingAction = {
  readonly type: 'set_agents_loading';
  readonly isLoading: boolean;
};

type DeactivateAgentAction = {
  readonly type: 'set_agent_deactivate';
  readonly agentID: string;
};

type SetAgentsErrorAction = {
  readonly type: 'set_agents_error';
  readonly err: APIError | null;
};

export type RiskAction =
  | SetAgentMapAction
  | SetAgentsErrorAction
  | DeactivateAgentAction
  | SetAgentsLoadingAction;

export const RISK_ACTIONS = {
  SET_AGENT_MAP: (agents: { data: RawAgent[] }): SetAgentMapAction => ({
    type: 'set_agents',
    clearStore: true,
    agentList: agents.data,
  }),
  UPDATE_AGENT_MAP: (agents: { data: RawAgent[] }): SetAgentMapAction => ({
    type: 'set_agents',
    clearStore: false,
    agentList: agents.data,
  }),
  SET_AGENTS_LOADING: (isLoading: boolean): SetAgentsLoadingAction => ({
    type: 'set_agents_loading',
    isLoading,
  }),
  DEACTIVATE_AGENT: (agentID: string): DeactivateAgentAction => ({
    type: 'set_agent_deactivate',
    agentID,
  }),
  SET_AGENTS_ERROR: (err: APIError | null): SetAgentsErrorAction => ({
    type: 'set_agents_error',
    err,
  }),
};
